module.exports = __webpack_public_path__ + "img/card.23e804ec.svg";